import React, {FC} from "react";
import styles from './card.module.css';

interface CardProps{
    img : string;
    para: string;
    img1 : string;
    para1: string;
    img2 : string;
    para2: string;
}

const Card: FC<CardProps>=({img,para,img1,para1,img2,para2})=>{
    return(
        <>
        <div className={styles.parent}>
            <div className={styles.contenir}>
                <div>
                    <img src={img} alt="" />
                    <h3>{para}</h3>
                </div>
                <div>
                    <img src={img1} alt="" />
                    <h3>{para1}</h3>

                </div>
                <div>
                <img src={img2} alt="" />
                    <h3>{para2}</h3>
                </div>
            </div>
            
        </div>
        </>
    );
}

export default Card;